import { UPDATE_MAP_BOUNDS_ACTION } from '@store/map/modules/actionTypes';

export const updateMapBoundsAction = (diff: kakao.maps.LatLngBounds) => ({
  type: UPDATE_MAP_BOUNDS_ACTION,
  payload: diff,
});

export type MapActionTypes = ReturnType<typeof updateMapBoundsAction>;
